export const GO_FLOATING_CHAT_TRIGGERS_CHAT_READY = Symbol.for('go_floating_chat_triggers_ready');
export const GO_FLOATING_CHAT_TRIGGERS_TOOLTIP_READY = Symbol.for('go_floating_chat_triggers_tooltip_ready');

export const EVENTS = {
    GO_OPEN_FLOATING_CHAT: 'go_open_floating_chat',
    GO_OPEN_FLOATING_CHAT_TOOLTIP: 'go_open_floating_chat_tooltip',
} as const;

export const EVENT_READY_SYMBOLS: { [key in keyof typeof EVENTS]?: symbol } = {
    GO_OPEN_FLOATING_CHAT: GO_FLOATING_CHAT_TRIGGERS_CHAT_READY,
    GO_OPEN_FLOATING_CHAT_TOOLTIP: GO_FLOATING_CHAT_TRIGGERS_TOOLTIP_READY,
};

export const POLLING_DELAY = 250;
export const EMITTER_TIMEOUT = 5000;
export const POLLING_ATTEMPTS = Math.floor(EMITTER_TIMEOUT / POLLING_DELAY);
